import { NgModule } from '@angular/core';
import {
  RecaptchaModule as RecaptchaModuleLib,
  RECAPTCHA_SETTINGS,
  RECAPTCHA_LOADER_OPTIONS,
  RecaptchaSettings
} from 'ng-recaptcha';

import { environment } from '@environments/environment';
import { TranslateService } from '../translate/services/translate.service';

@NgModule({
  imports: [RecaptchaModuleLib],
  exports: [RecaptchaModuleLib],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.RECAPTCHA_SITE_KEY,
        size: 'invisible'
      } as RecaptchaSettings
    },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) => ({
        onBeforeLoad(url) {
          url.searchParams.set('hl', translateService.getLocale(true).toLowerCase());
          return { url };
        }
      })
    }
  ]
})
export class RecaptchaModule {}
